/** The file was automatically generated. Please do not modify manually */
import de from './online.json';
export var strings_de = de;
